import { GlobalStyles, stepClasses, StepIndicator } from '@mui/joy';
import Step from '@mui/joy/Step';
import Stepper from '@mui/joy/Stepper';
import { RefObject } from 'react';

import { PLACE_TYPE_DRIVER_BREAK, PLACE_TYPE_PARKING } from '../../../constants.ts';
import { Place } from '../../../schema/Place.ts';
import { getConnectorUi, getRoadmapTextClass, getStepIndicatorUi } from '../../../utils/roadmapUtils.ts';
import { FormatTime } from '../../../utils/utils.ts';

export interface RoadmapStepperProps {
  places: Place[];
  currentPlace: Place;
  nextPlace: Place;
  onPlaceClick: (place: Place) => void;
  scrollRef: RefObject<HTMLButtonElement | null>;
}

export function RoadmapStepper(props: Readonly<RoadmapStepperProps>) {
  return (
    <Stepper
      sx={{
        '--Step-connectorThickness': '12px',
        '--Step-connectorInset': '-2px',
        '--Step-connectorRadius': '0px',
        '--Step-gap': '0px',
        '--StepIndicator-size': '25px',
        '--joy-palette-success-solidBg': 'var(--joy-palette-success-400)',
        [`& .${stepClasses.vertical}`]: {
          minWidth: '175px',
          '&::after': {
            background: '#F2F2F2',
          },
        },
        [`& .${stepClasses.completed}`]: {
          '&::after': { bgcolor: '#4385E8' },
        },
      }}>
      <GlobalStyles
        styles={{
          '@keyframes glowSweep': {
            from: { backgroundPosition: '200% 0' },
            to: { backgroundPosition: '-200% 0' },
          },
        }}
      />
      {props.places.map((place, i) => (
        <Step
          key={place.id}
          completed={i < props.currentPlace?.order}
          active={i === props.currentPlace?.order}
          disabled={i === props.places.length - 1}
          orientation="vertical"
          sx={{
            [`&.${stepClasses.vertical}::after`]: getConnectorUi(i, props.currentPlace, props.nextPlace),
          }}
          indicator={
            <StepIndicator
              onClick={() => props.onPlaceClick(place)}
              sx={getStepIndicatorUi(i, props.currentPlace, props.nextPlace)}>
              {[PLACE_TYPE_PARKING, PLACE_TYPE_DRIVER_BREAK].includes(place.type) && (
                <img src={'/theme/media/parking.svg'} width="12" height="12" alt="Clock icon" />
              )}
            </StepIndicator>
          }>
          <button
            type="button"
            ref={i === props.nextPlace?.order ? props.scrollRef : null}
            className={'text-basic text-hover bg-transparent border-0 p-0 m-0'}
            style={{ appearance: 'none' }}
            onClick={() => props.onPlaceClick(place)}>
            {place.name}
          </button>
          <button
            type="button"
            ref={i === props.currentPlace?.order ? props.scrollRef : null}
            className={`${getRoadmapTextClass(place)} bg-transparent border-0 p-0 m-0`}
            style={{ appearance: 'none' }}
            onClick={() => props.onPlaceClick(place)}>
            {FormatTime(place.arrival_time, false)} - {FormatTime(place.departure_time, false)}
          </button>
        </Step>
      ))}
    </Stepper>
  );
}
